module.exports = __webpack_public_path__ + "img/DownloadKH.ae23904c.png";